export default __webpack_public_path__ + "media/sub_banner_mobile_en.afb6131c.png";